// extracted by mini-css-extract-plugin
module.exports = {"visually-hidden":"adv-light_visually-hidden__dYkg7","adv-light":"adv-light_adv-light__LRC8x"};